export default [
    {
        path: '/coworking',
        name: 'coworking.list',
        component: () => import("@/pages/Coworkings/Catalog")
    },
    {
        path: '/coworking/:id',
        name: 'coworking.show',
        component: () => import("@/pages/Coworkings/Coworking")
    },
];